import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const {FiPhone, FiMail, FiMapPin} = FiIcons;

const contacts = [
  [FiPhone, 'Phone (Sri Lanka)', '077 072 9637', 'tel:0770729637'],
  [FiPhone, 'Phone (Bahrain)', '+973 3958 1410', 'tel:+97339581410'],
  [FiMail, 'Email', 'info@zevilanka.com', 'mailto:info@zevilanka.com'],
  [FiMail, 'Customer care', 'customercare@zevism.lk', 'mailto:customercare@zevism.lk'],
  [FiMapPin, 'Location', 'Colombo, Sri Lanka', null]
];

function Contact() {
  return (
    <section className="contact section" id="contact">
      <header className="section-heading">
        <span className="eyebrow">We Are Here</span>
        <h2>Connect With ZEVI</h2>
      </header>
      <div className="contact-grid commerce-contact-grid">
        {contacts.map(([icon, label, value, href]) => (
          <div className="contact-item" key={label}>
            <SafeIcon icon={icon} />
            <div>
              <span>{label}</span>
              {href ? <a href={href}>{value}</a> : <p>{value}</p>}
            </div>
          </div>
        ))}
      </div>
      <div className="contact-actions">
        <a className="gold-button" href="#collection">Shop the collection</a>
        <a className="outline-button" href="mailto:info@zevilanka.com">
          Contact us
        </a>
      </div>
    </section>
  );
}

export default Contact;